import './index.less';
import Tabs from './Tabs';
Tabs.install = function(Vue) {
  Vue.component(Tabs.name, Tabs);
};

export default Tabs;
